import { useMemo } from 'react';
import { PaymentsFeatureFlags } from '@frontend/payments-hooks';
import { useScopedAppFlagStore } from '@frontend/scope';
import { RegisterTerminalModalType } from '../types';
import { getStepperSteps, StepperStep } from '../utils';
import { RegisterTerminalModalJustifiSteps, RegisterTerminalModalStripeSteps } from './use-register-terminal-modal';

interface RegisterTerminalState {
  steps: StepperStep[];
  initialStep: RegisterTerminalModalJustifiSteps | RegisterTerminalModalStripeSteps;
  hasJustifyOnboardingEnabled: boolean;
  type: RegisterTerminalModalType;
}

export const useRegisterTerminalState = (): RegisterTerminalState => {
  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const hasJustifyOnboardingEnabled = getFeatureFlagValue(PaymentsFeatureFlags.EnableJustifyOnboarding);

  const steps = useMemo(
    () =>
      getStepperSteps(
        hasJustifyOnboardingEnabled ? RegisterTerminalModalType.Justifi : RegisterTerminalModalType.Stripe
      ),
    [hasJustifyOnboardingEnabled]
  );
  const initialStep = useMemo(
    () =>
      hasJustifyOnboardingEnabled
        ? RegisterTerminalModalJustifiSteps.PreCheck
        : RegisterTerminalModalStripeSteps.InstallBattery,
    [hasJustifyOnboardingEnabled]
  );

  return {
    steps,
    initialStep,
    hasJustifyOnboardingEnabled,
    type: hasJustifyOnboardingEnabled ? RegisterTerminalModalType.Justifi : RegisterTerminalModalType.Stripe,
  };
};
